/**************************************** First On load to get the products *******************************/
let closeMatchAPI = false;
$(document).ready(function () {
  $(window).on("scroll.recommend", function () {
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var section = $(".ct_recommand");
    var offset = section.offset().top;

    // Check if the section is in view
    if (scrollTop + windowHeight >= offset) {
      //section.fadeIn(); // Load the content (e.g., show the section)
      data_add();
      $(window).off("scroll.recommend"); // Optional: Remove scroll event listener if only want to load once
    }
  });

  var startY;
  $(".Product-pop-content").on("touchstart", function (event) {
    var touch = event.touches[0];
    startY = touch.clientY;
  });

  $(".Product-pop-content").on("touchmove", function (event) {
    if (!startY) {
      return;
    }

    var touch = event.touches[0];
    var deltaY = touch.clientY - startY;
    if (deltaY > 10) {
      // Swipe down
      var $scrollableDiv = $(".Product-pop-content");

      $scrollableDiv.on("scroll", function () {
        if ($scrollableDiv.scrollTop() === 0) {
          jQuery(".CT_element_content_open").removeClass("ct_swipe_up");
          jQuery(".Pro_rec_active").removeClass("ct_main_swipe_up");
        }
      });
      if ($scrollableDiv.scrollTop() === 0) {
        jQuery(".CT_element_content_open").removeClass("ct_swipe_up");
        jQuery(".Pro_rec_active").removeClass("ct_main_swipe_up");
      }
    } else if (deltaY < -5) {
      // Swipe up
      jQuery(".CT_element_content_open").addClass("ct_swipe_up");
      jQuery(".Pro_rec_active").addClass("ct_main_swipe_up");
    }

    // Reset startY to allow for multiple swipes
    startY = null;
  });
});
function data_add() {
  var selectedVariantName = $.trim(
    $("form [name='id'] option:selected").text()
  );
  var selectedSKU = $("form [name='id'] option:selected").data("sku");
  closeMatchAPI = true;
  var spit_color = selectedVariantName.split("/");
  var var_text = spit_color[0] + " " + spit_color[1];
  var s_clr = "";
  var f_clr = "";
  var cl_polish_arr = [];
  var element = {};
  var first_clr = "";
  var second_clr = "";
  var scan_second = "";
  var scan_first = "";

  jQuery(
    ".option-selectors .option-selector  .option-selector__btns .opt-btn:checked"
  ).each(function (i) {
    var variant_value = jQuery(this).val();
    var check_color = jQuery(this)
      .closest(".option-selector")
      .find(".opposing-items .label")
      .text();

    if (check_color.indexOf("Color") != -1) {
      var color_arr = [];
      f_clr = jQuery(this).val().toLowerCase();
      var main_f_clr = jQuery(this).val();
      var split_val = main_f_clr.split("-");
      var fir_color = "";
      fir_color = split_val[0];
      //   if(split_val[0] == "Ruby")
      //   {
      //     fir_color="Red"
      //   }
      // else
      // {
      //   fir_color=split_val[0]
      // }
      color_arr.push(fir_color);
      element["product_color_searchtap"] = color_arr;
    }
    if (check_color.indexOf("Meena") != -1) {
      var meena_polish_arr = [];

      s_clr = jQuery(this).val().toLowerCase();
      var main_s_clr = jQuery(this).val();
      var split_val = main_s_clr;
      meena_polish_arr.push(split_val);
      element["product_Meena Polish"] = meena_polish_arr;
    } else {
      if (check_color.indexOf("Polish") != -1) {
        var polish_arr = [];

        s_clr = jQuery(this).val().toLowerCase();
        var main_s_clr = jQuery(this).val();
        var split_val = main_s_clr.split("-");
        polish_arr.push(split_val);
        element["product_Polish"] = polish_arr[0];
      }
    }
    var_text += variant_value + " ";
  });

  if (f_clr != "" || s_clr != "") {
    var_text = f_clr + " " + s_clr;
    jQuery(
      ".ct_wrap_variant .ct_swatch .option-selector_inner .ct_option_select"
    ).each(function () {
      var selected_val = jQuery(this).val().toLowerCase();

      if (f_clr == selected_val) {
        $(this).prop("checked", true);
      } else if (s_clr == selected_val) {
        $(this).prop("checked", true);
      }
    });

    $('[data-swatch="' + f_clr + '"] ').each(function () {
      var bgColor = $(this).css("--swatch-background-color");
      scan_first = bgColor;
      first_clr = hexToRgb(bgColor);
    });

    $('[data-swatch="' + s_clr + '"] ').each(function () {
      var bgColor = $(this).css("--swatch-background-color");
      scan_second = bgColor;
      second_clr = hexToRgb(bgColor);
    });
  }
  var gradient =
    "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(" +
    first_clr["r"] +
    "," +
    first_clr["g"] +
    "," +
    first_clr["b"] +
    ",1) 37%, rgba(" +
    second_clr["r"] +
    "," +
    second_clr["g"] +
    "," +
    second_clr["b"] +
    ",1) 58%, rgba(255,255,255,1) 100%)";
  var scan_gr =
    "linear-gradient(180deg," +
    scan_first +
    ", rgba(" +
    second_clr["r"] +
    "," +
    second_clr["g"] +
    "," +
    second_clr["b"] +
    ",48%) 64.2%,#fff0)";
  var counter_color =
    "linear-gradient(#ffffff, #ffffff), linear-gradient(180deg, " +
    scan_first +
    ", " +
    scan_second +
    ")";

  var first_color =
    "linear-gradient(283deg, rgba(" +
    first_clr["r"] +
    "," +
    first_clr["g"] +
    "," +
    first_clr["b"] +
    ",0.8) 0%, rgba(" +
    first_clr["r"] +
    "," +
    first_clr["g"] +
    "," +
    first_clr["b"] +
    ",1) 51%)";
  var second_color =
    "linear-gradient(283deg, rgba(" +
    second_clr["r"] +
    "," +
    second_clr["g"] +
    "," +
    second_clr["b"] +
    ",0.39) 0%, rgba(" +
    first_clr["r"] +
    "," +
    first_clr["g"] +
    "," +
    first_clr["b"] +
    ",0.51) 55%)";
  var third_color =
    "linear-gradient(283deg, rgba(" +
    second_clr["r"] +
    "," +
    second_clr["g"] +
    "," +
    second_clr["b"] +
    ",0.5130427170868348) 0%, rgba(" +
    second_clr["r"] +
    "," +
    second_clr["g"] +
    "," +
    second_clr["b"] +
    ",0.8883928571428571) 51%)";

  $(".ct_color_bg").css({
    background: gradient,
    "background-size": "120%",
  });
  $(".CT_scan").css({
    background: scan_gr,
  });
  $(".Product-recommendation-inner .ct_match_product_count").css({
    "background-image": counter_color,
  });
  $(".Product-pop-content-right-head .ct_match_product_count_css").css({
    "background-image": counter_color,
  });
  $(".ct_first_sec").css({
    "background-image": first_color,
  });
  $(".ct_third").css({
    "background-image": second_color,
  });
  $(".ct_fourth_fifth").css({
    "background-image": third_color,
  });
  jQuery(".ct_recommand").show();
  jQuery(".ct_rec_loader").show();
  jQuery(".ct_product_image").hide();
  jQuery(".ct_match_product_count").hide();

  var main_text_title = jQuery.trim(jQuery(".title-row .title").text());
  var prod_main_title = main_text_title.substring(
    0,
    main_text_title.lastIndexOf(" ")
  );

  var earing_style_text = "";
  var neckless_set = "";
  jQuery(".cc-accordion-item__content table tbody tr th").each(function () {
    var t = jQuery.trim(jQuery(this).text());

    if (main_text_title.toLowerCase().indexOf("necklace") !== -1) {
      if (t.toLowerCase().indexOf("necklace style") !== -1) {
        earing_style_text = jQuery(this).next().text();
        //earing_style_text = earing_style_text.replace(" ", "");
      }
      if (t.toLowerCase().indexOf("necklace set") !== -1) {
        var neckless_text = jQuery(this).next().text();
        //neckless_text = neckless_text.replace(" ", "");

        if (neckless_text == "Yes") {
          neckless_set = "Necklace Set";
        }
      }
    } else if (t.toLowerCase().indexOf("sheeshphool") !== -1) {
      var neckless_text = jQuery(this).next().text();
      // neckless_text = neckless_text.replace(" ", "");

      if (neckless_text == "Yes") {
        neckless_set = "Sheeshphool";
      }
    } else if (t.toLowerCase().indexOf("bangle type") !== -1) {
      earing_style_text = jQuery(this).next().text();
      //earing_style_text = earing_style_text.replace(" ", "");
    } else if (t.toLowerCase().indexOf("earring style") !== -1) {
      earing_style_text = jQuery(this).next().text();
    } else if (t.toLowerCase().indexOf("style") !== -1) {
      earing_style_text = jQuery(this).next().text();
      //earing_style_text = earing_style_text.replace(" ", "");
    }
  });
  if (element["product_color_searchtap"]) {
    var colors = [...element["product_color_searchtap"]];
    delete element["product_color_searchtap"];
  }
  var final_text =
    earing_style_text + " " + prod_main_title + " " + neckless_set;

  var settings = {
    url: "https://middleware.technoboost.in/api/v1/callback/similar-products",
    data: {
      sku: selectedSKU,
    },
    type: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  $.ajax(settings)
    .done(function (first_response) {
      $(".Product-pop-content-right").animate({ scrollTop: 0 }, "slow");

      const closeMatchContainer = document.querySelector(
        ".product-close-match"
      );
      let total_prods = first_response.product.length;
      if (closeMatchContainer) {
        if (total_prods < 3) {
          closeMatchContainer.addEventListener("click", function () {
            // Call the CT_pop function
            closeModalBundle();
            document.getElementById("view_similar").scrollIntoView({ behavior: "smooth" });

            // Fetch product details
            let currentProd = document.querySelector(".product-related-container");

            if (currentProd) {
              let prdTitle = currentProd.getAttribute("data-prod-name");
              let prdPrice = currentProd.getAttribute("data-prod-price");
              let prdId = currentProd.getAttribute("data-prod-id");

              // Push event to CleverTap
              clevertap.event.push("Similar_Bundling", {
                "Product Name": prdTitle,
                "Product Price": prdPrice,
                "Product ID": prdId, // Removed extra space in key name
              });
            }
          });
        } else {
          closeMatchContainer.addEventListener("click", function () {
            // Call the CT_pop function
            CT_pop();

            // Fetch product details
            let currentProd = document.querySelector(
              ".product-related-container"
            );
            if (currentProd) {
              let prdTitle = currentProd.getAttribute("data-prod-name");
              let prdPrice = currentProd.getAttribute("data-prod-price");
              let prdId = currentProd.getAttribute("data-prod-id");

              // Push event to CleverTap
              clevertap.event.push("Similar_Bundling", {
                "Product Name": prdTitle,
                "Product Price": prdPrice,
                "Product ID": prdId,
              });
            }
          });
        }
      }

      var second_api_text = "";
      var counter = 0;
      var prod_html = "";
      var selectedVariantName = $.trim(
        $("form [name='id'] option:selected").text()
      );
      var split_value = selectedVariantName.split("/");
      var first_variant,
        second_variant,
        third_variant = "";

      var image_html = "";
      var last_img = "";
      var length = first_response.product.length;

      jQuery.each(first_response.product, function (i, val) {
        if (val.groupId != "" && val.name != main_text_title) {
          counter++;
          var tag_name = "";
          var limited_price = false;
          var limited_discount = false;
          var bargain = false;
          var fast_sell = false;
          var bestSel = "";
          var flag_search_best_seller = false;
          var other_tag_seller = false;
          var ct_best_class = "";
          var tag_class = "";
          var best_seller = "";
          var discount_price = "";
          var var_count = "";
          var silverTag = "";
          var discountPercentage =
            ((val.price - val.sellingPrice) * 100) / val.price;

          if (
            discountPercentage &&
            discountPercentage >= 10 &&
            discountPercentage <= 40
          ) {
            limited_discount = true;
          }

          if (
            val.sellingPrice &&
            val.sellingPrice >= 1300 &&
            val.sellingPrice <= 2000
          ) {
            limited_price = true;
          }
          if (val.sellingPrice && val.sellingPrice > 2000) {
            bargain = true;
          }
          if (limited_discount && limited_price) {
            bestSel = "Limited Deal";
            fast_sell = true;
            ct_best_class = "limited_tag";
          }
          if (bargain && limited_discount) {
            bestSel = "Price Crash";
            fast_sell = true;
            ct_best_class = "bargain_tag";
          }

          // TO CHECK
          // if (val.discount) {
          //   var dis_price = parseInt(val.discount);
          //   if (dis_price > 1000) {
          //     discount_price =
          //       '<div class="pr_price_off" bis_skin_checked="1"> <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"> <g clip-path="url(#clip0_605_63842)"> <path d="M13.4475 7.55371V7.87384C13.4475 9.66639 10.4372 11.1194 6.72415 11.1194C4.67457 11.1194 2.84039 10.6762 1.60718 9.97799C2.02299 11.5929 4.84886 12.9295 8.27568 12.9295C11.9888 12.9295 14.999 11.3604 14.999 9.56786C14.999 8.77968 14.4156 8.08511 13.4475 7.55371Z" fill="#FCC62D"></path> <path d="M8.27557 12.929C4.56249 12.929 1.55225 11.3599 1.55225 9.56738V11.7519C1.55225 13.5445 4.56249 14.9978 8.27557 14.9978C11.9887 14.9978 14.9989 13.5445 14.9989 11.7519V9.56738C14.9989 11.3599 11.9887 12.929 8.27557 12.929Z" fill="#E4AF18"></path> <path d="M2.32788 13.2781C2.48045 13.4175 2.65345 13.5509 2.84506 13.6776V11.5337C2.65345 11.4018 2.48045 11.2634 2.32788 11.1191V13.2781Z" fill="#CE9912"></path> <path d="M13.7061 11.5337V13.6776C13.8977 13.5512 14.0707 13.4175 14.2232 13.2781V11.1191C14.0709 11.2634 13.8979 11.4018 13.7061 11.5337Z" fill="#CE9912"></path> <path d="M3.3623 13.9792C3.52573 14.0637 3.69847 14.1436 3.87948 14.2194V12.1008C3.69847 12.0211 3.52573 11.9371 3.3623 11.8486V13.9792Z" fill="#CE9912"></path> <path d="M12.6716 14.2194C12.8526 14.1439 13.0254 14.0637 13.1888 13.9792V11.8486C13.0254 11.9371 12.8526 12.0214 12.6716 12.1008V14.2194Z" fill="#CE9912"></path> <path d="M4.39673 14.4144C4.56378 14.4716 4.73626 14.5248 4.91391 14.5745V12.4763C4.73626 12.4235 4.56378 12.3669 4.39673 12.3066V14.4144Z" fill="#CE9912"></path> <path d="M11.6375 14.5745C11.8151 14.5248 11.9876 14.4716 12.1546 14.4144V12.3066C11.9876 12.3669 11.8151 12.4235 11.6375 12.4763V14.5745Z" fill="#CE9912"></path> <path d="M5.6897 14.7621C5.85856 14.7962 6.03129 14.8267 6.20688 14.8539V12.7738C6.03129 12.7446 5.85856 12.712 5.6897 12.6758V14.7621Z" fill="#CE9912"></path> <path d="M10.3442 14.8522C10.5198 14.8248 10.6926 14.7943 10.8614 14.7604V12.6738C10.6926 12.71 10.5198 12.7426 10.3442 12.7721V14.8522Z" fill="#CE9912"></path> <path d="M7.24146 14.972C7.41161 14.9846 7.58434 14.9934 7.75863 14.9996V12.9301C7.58434 12.9234 7.41161 12.9141 7.24146 12.9004V14.972Z" fill="#CE9912"></path> <path d="M8.79272 14.9999C8.96701 14.9934 9.13975 14.9849 9.3099 14.9722V12.9004C9.13975 12.9141 8.96701 12.9234 8.79272 12.9304V14.9999Z" fill="#CE9912"></path> <path d="M6.72406 9.04819C3.01097 9.04819 0.000732422 7.47907 0.000732422 5.68652V7.87109C0.000732422 9.66363 3.01097 11.1169 6.72406 11.1169C10.4371 11.1169 13.4474 9.66363 13.4474 7.87109V5.68652C13.4474 7.47907 10.4371 9.04819 6.72406 9.04819Z" fill="#E4AF18"></path> <path d="M0.776611 9.39699C0.929179 9.53637 1.10218 9.6698 1.29379 9.79651V7.65254C1.10218 7.52066 0.929179 7.38232 0.776611 7.23828V9.39699Z" fill="#CE9912"></path> <path d="M12.1545 7.6528V9.79677C12.3462 9.67032 12.5192 9.53662 12.6717 9.39724V7.23828C12.5194 7.38257 12.3464 7.52092 12.1545 7.6528Z" fill="#CE9912"></path> <path d="M1.81079 10.0983C1.97422 10.1829 2.14696 10.2628 2.32797 10.3385V8.2199C2.14696 8.14025 1.97422 8.05621 1.81079 7.96777V10.0983Z" fill="#CE9912"></path> <path d="M11.1201 10.3385C11.3011 10.263 11.4739 10.1831 11.6373 10.0983V7.96777C11.4739 8.05621 11.3011 8.14051 11.1201 8.2199V10.3385Z" fill="#CE9912"></path> <path d="M2.84521 10.5335C3.01226 10.5907 3.18474 10.644 3.36239 10.6936V8.59542C3.18474 8.54266 3.01226 8.48603 2.84521 8.42578V10.5335Z" fill="#CE9912"></path> <path d="M10.0857 10.6936C10.2633 10.644 10.4358 10.5907 10.6029 10.5335V8.42578C10.4358 8.48603 10.2633 8.54266 10.0857 8.59542V10.6936Z" fill="#CE9912"></path> <path d="M4.13818 10.8812C4.30704 10.9154 4.47978 10.9459 4.65536 10.973V8.89293C4.47978 8.86371 4.30704 8.83112 4.13818 8.79492V10.8812Z" fill="#CE9912"></path> <path d="M8.79272 10.9733C8.96831 10.9459 9.14104 10.9154 9.3099 10.8815V8.79492C9.14104 8.83112 8.96831 8.86371 8.79272 8.89319V10.9733Z" fill="#CE9912"></path> <path d="M5.6897 11.0921C5.85985 11.1047 6.03259 11.1135 6.20688 11.1197V9.05025C6.03259 9.04352 5.85985 9.03421 5.6897 9.02051V11.0921Z" fill="#CE9912"></path> <path d="M7.24146 11.12C7.41574 11.1135 7.58848 11.105 7.75863 11.0923V9.02051C7.58848 9.03421 7.41574 9.04352 7.24146 9.0505V11.12Z" fill="#CE9912"></path> <path d="M13.2709 8.61133C12.5786 10.0481 9.91156 11.1191 6.72418 11.1191C5.53364 11.1191 4.41601 10.9691 3.44604 10.7072C4.38421 11.3441 6.05392 11.8861 8.27572 11.8861C11.8137 11.8861 13.9647 10.5127 13.9647 9.56759C13.9647 9.25211 13.7219 8.9175 13.2709 8.61133Z" fill="#FFD949"></path> <path d="M8.01701 8.53354C4.30392 8.53354 1.29368 7.08026 1.29368 5.28772V3.82617C0.48145 4.33533 0.000732422 4.97379 0.000732422 5.68905C0.000732422 7.48159 3.01097 9.05071 6.72406 9.05071C8.51195 9.05071 10.1354 8.68636 11.3396 8.10893C10.3593 8.37864 9.22591 8.53354 8.01701 8.53354Z" fill="#FFD949"></path> <path d="M8.01727 6.46225C4.30419 6.46225 1.29395 4.89313 1.29395 3.10059V5.28515C1.29395 7.07769 4.30419 8.53096 8.01727 8.53096C11.7304 8.53096 14.7406 7.07769 14.7406 5.28515V3.10059C14.7406 4.89313 11.7304 6.46225 8.01727 6.46225Z" fill="#E4AF18"></path> <path d="M2.06934 6.81105C2.2219 6.95043 2.3949 7.08386 2.58651 7.21057V5.0666C2.3949 4.93472 2.2219 4.79638 2.06934 4.65234V6.81105Z" fill="#CE9912"></path> <path d="M13.4475 5.06686V7.21083C13.6391 7.08438 13.8121 6.95069 13.9647 6.81131V4.65234C13.8124 4.79664 13.6394 4.93498 13.4475 5.06686Z" fill="#CE9912"></path> <path d="M3.10376 7.51333C3.26719 7.59789 3.43993 7.67779 3.62094 7.75356V5.63494C3.43993 5.55529 3.26719 5.47125 3.10376 5.38281V7.51333Z" fill="#CE9912"></path> <path d="M12.4131 7.75258C12.5941 7.67708 12.7668 7.59717 12.9303 7.51235V5.38184C12.7668 5.47027 12.5941 5.55457 12.4131 5.63396V7.75258Z" fill="#CE9912"></path> <path d="M4.13818 7.94761C4.30523 8.00476 4.47771 8.05802 4.65536 8.10767V6.00948C4.47771 5.95673 4.30523 5.9001 4.13818 5.83984V7.94761Z" fill="#CE9912"></path> <path d="M11.3787 8.10767C11.5563 8.05802 11.7288 8.00476 11.8958 7.94761V5.83984C11.7288 5.9001 11.5563 5.95673 11.3787 6.00948V8.10767Z" fill="#CE9912"></path> <path d="M5.43115 8.29528C5.60001 8.32942 5.77275 8.35993 5.94833 8.38708V6.30699C5.77275 6.27777 5.60001 6.24519 5.43115 6.20898V8.29528Z" fill="#CE9912"></path> <path d="M10.0857 8.38734C10.2613 8.35993 10.434 8.32942 10.6029 8.29554V6.20898C10.434 6.24519 10.2613 6.27777 10.0857 6.30725V8.38734Z" fill="#CE9912"></path> <path d="M6.98291 8.50515C7.15306 8.51783 7.3258 8.52662 7.50009 8.53282V6.46333C7.3258 6.45661 7.15306 6.4473 6.98291 6.43359V8.50515Z" fill="#CE9912"></path> <path d="M8.53418 8.53308C8.70847 8.52662 8.88121 8.51808 9.05136 8.50541V6.43359C8.88121 6.4473 8.70847 6.45661 8.53418 6.46359V8.53308Z" fill="#CE9912"></path> <path d="M14.7406 3.10307C14.7406 4.89562 11.7304 6.46474 8.01727 6.46474C4.30419 6.46474 1.29395 4.89562 1.29395 3.10307C1.29395 1.31053 4.30419 0 8.01727 0C11.7304 0 14.7406 1.31053 14.7406 3.10307Z" fill="#FCC62D"></path> <path d="M8.01685 5.42121C4.47883 5.42121 2.32788 4.0481 2.32788 3.1027C2.32788 2.15755 4.47883 0.775391 8.01685 0.775391C11.5549 0.775391 13.7058 2.15755 13.7058 3.1027C13.7058 4.0481 11.5549 5.42121 8.01685 5.42121Z" fill="#FFD949"></path> <path d="M9.77073 3.45478C9.98277 3.40978 10.1072 3.27894 10.0614 3.12973L10.0122 2.97044C9.97631 2.8533 9.83641 2.75555 9.66496 2.70694C9.43172 2.20864 8.83696 2.02814 7.95362 2.02814C7.91173 2.02814 7.87087 2.02917 7.83053 2.03073C7.52902 2.04314 7.22828 2.01418 6.99374 1.92832C6.89806 1.89341 6.82022 1.85695 6.76876 1.81894C6.74549 1.80187 6.68912 1.81273 6.68912 1.83446C6.68912 1.87221 6.69196 1.91695 6.70024 1.9666C6.7323 2.15976 6.69403 2.1308 6.50319 2.32345C6.39251 2.43568 6.30434 2.56497 6.24046 2.70771C6.07005 2.75659 5.93093 2.85407 5.89499 2.9707L5.84586 3.12999C5.80009 3.2792 5.92447 3.41004 6.13651 3.45504C6.19702 3.83671 6.45639 4.17185 7.02192 4.35648L6.99089 4.62464C6.98262 4.69627 6.92081 4.76247 6.83082 4.79505L5.69019 5.20672C6.35631 5.34636 7.11553 5.43066 7.95362 5.43066C8.78007 5.43066 9.52972 5.34869 10.1891 5.21293L9.07331 4.79582C8.98513 4.76272 8.92462 4.69704 8.91661 4.62671L8.88532 4.35648C9.45085 4.17185 9.71022 3.83646 9.77073 3.45478Z" fill="#F0C41B"></path> </g> <defs> <clipPath id="clip0_605_63842"> <rect width="15" height="15" fill="white"></rect> </clipPath> </defs> </svg>  Big Save <span> ₹' +
          //       val.discount +
          //       '</span> </div>';
          //   }
          // }

          jQuery.each(first_response.product, function (j, attr) {
            if (attr.name == "Front End Tags") {
              silverTag =
                '<div class="pr__overlay" bis_skin_checked="1"> <span>' +
                attr.values[0].value[0] +
                "</span>  </div>";
            }
            if (attr.name == "Bestseller") {
              flag_search_best_seller = true;
            }
          });

          // if (flag_search_best_seller) {
          //   ct_best_class = 'bargain_tag';
          //   tag_class = 'ct_best';
          //   best_seller = 'Best Seller';
          // } else {
          //   if (fast_sell) {
          //     tag_class = ct_best_class;
          //     best_seller = bestSel;
          //   }
          // }

          // var swatches = val.swatches;

          // if (swatches) {
          //   if (swatches[0]) {
          //     if (swatches[0].values.length > 1) {
          //       var_count =
          //         '<div class="pr_CPB-varient"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none"> <circle cx="4.55419" cy="4.22899" r="4.08544" fill="#B13939"/> <circle cx="6.46825" cy="4.22899" r="4.08544" fill="#28BE7F"/> <circle cx="8.49364" cy="4.22899" r="4.08544" fill="#14577C"/> </svg> ' +
          //         swatches[0].values.length +
          //         '+</div>';
          //     }
          //   }
          // }
          var clr_variant_first = "";
          var clr_variant_second = "";
          var clr_variant_third = "";

          // jQuery.each(val['attributes'], function (attr_key, attr_value) {
          //   if (attr_value.id == 'product_Color') {
          //     clr_variant_first = attr_value['values'][0]['value'][0];
          //   }
          //   if (attr_value.id == 'product_Polish') {
          //     clr_variant_second = attr_value['values'][0]['value'][0];
          //   }
          //   if (attr_value.id == 'product_Size') {
          //     clr_variant_third = attr_value['values'][0]['value'][0];
          //   }
          // });
          var final_variant = "";
          // console.log(clr_variant_first + ' == ' + clr_variant_second);
          // if (clr_variant_first != '' && clr_variant_second != '' && clr_variant_third != '') {
          //   final_variant = clr_variant_first + ' / ' + clr_variant_second + ' / ' + clr_variant_third;
          // } else if (clr_variant_first != '' && clr_variant_second != '') {
          //   final_variant = clr_variant_first + ' / ' + clr_variant_second;
          // } else if (clr_variant_first != '' && clr_variant_third != '') {
          //   final_variant = clr_variant_first + ' / ' + clr_variant_third;
          // } else if (clr_variant_first != '') {
          //   final_variant = clr_variant_first;
          // }

          var compare_price = val.sellingPrice;
          var main_price = val.price;
          var hide_compare_price = "";
          if (val.price > val.sellingPrice) {
            compare_price = val.sellingPrice;
            main_price = val.price;
          } else {
            hide_compare_price = "ct_cmp_price_hide";
            compare_price = val.sellingPrice;
            main_price = "";
          }

          var discount = "";
          var dis_hide = "dis_hide";
          if (discountPercentage > 0) {
            dis_hide = "dis_show";
            discount = discountPercentage;
          }
          var tag_html = "";
          // if (best_seller != '') {
          //   var tag_html = '<div class="pr_CPB-tags ' + tag_class + '">' + best_seller + '</div>';
          // }

          // Get the current URL
          // var url = val.url;

          // Split the URL by '/'
          // var segments = url.split('/');

          // Get the last segment (after the last '/')
          // var lastSegment = segments[segments.length - 1];

          // var parts = lastSegment.split('?');

          // Get the first part (before '?')
          // var valueBeforeQuestionMark = parts[0];

          prod_html +=
            '<div class="pr_CPB-box"' +
            '" data-product-id="' +
            val.groupId +
            '">';
          prod_html +=
            '<div class="wrap_close_match"><a href=" /products/' +
            val.handle +
            '"><div class="pr_CPB-image-main">' +
            tag_html +
            ' <div class="pr_CPB-image"><img src="' +
            val.image +
            '" alt="pr_main_img" class="pr_main_img"> </div>';
          prod_html +=
            '<div class="pr_CPB-product-content"> <div class="pr_CPB-product-title"><div class="pr_CPB-product-title-text">' +
            val.name +
            "</div></div>";
          prod_html +=
            var_count +
            '<div class="wish_added" style="display: none;"><h2>Added To Wishlist</h2></div><div class="rb_wish_remove" style="display: none;"><h2>Removed From Wishlist</h2></div>  </div></a>';
          prod_html += `<div class="ct_close_match">
          <div class="ct_hart_icon_main">
            <div class="ct_hart_icon ct_hart_icon-media">
                <div class="wishlist_img_main" data-prod-sku="${val.sku}" data-prod-id="${val.groupId}" data-prod-type="Temple Finger Ring" data-prod-metafiled-type="${val.category}" data-prod-title="${val.name}" data-prod-featured-image="${val.image}" data-prod-variant-id="${val.id}" data-prod-price="${val.sellingPrice}" data-prod-selling-price="${val.price}">
                  <img class="wish_uncheck wishlist_blank_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_uncheck.webp?v=1734585398" loading="lazy">
                  <img class="wish_fill wishlist_fill_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_fill.png" loading="lazy">
                </div>
              </div>
              <div class="wish_added" style="display: none;">
                <h2>Added To Wishlist</h2>
              </div>
              <div class="rb_wish_remove" style="display: none;">
                <h2>Removed From Wishlist</h2>
              </div>
            </div>
            </div></div>`;

          prod_html +=
            '<div class="pr_CPB-product-price"><div class="pr_CPB-product-price-big">₹' +
            compare_price +
            '</div><div class="pr_CPB-product-price-small ' +
            hide_compare_price +
            '">₹' +
            main_price +
            '</div><div class="pr_CPB-product-price-label ' +
            dis_hide +
            '">' +
            discount +
            "% OFF</div></div>";

          prod_html +=
            '<div class="pr_CPB-product-tags"> <div class="pr_tag" bis_skin_checked="1"> ' +
            silverTag +
            " " +
            discount_price +
            " </div> </div>";
          prod_html += "</div></div>";
        }

        if (i < 3) {
          // second_api_text = val['categories'][1]['name'];
          //third_api_text=val['categories'][0]["name"]
          image_html +=
            '<img alt="Product-rec-img" src="' +
            val.image +
            '" class="main_img"></img>';
        } else {
          // return false;
        }

        if (i === length - 1) {
          last_img += val.image;
        }
      });

      // var total_prod = first_response.product.length;
      if (counter > 2) {
        if (counter == 1) {
          jQuery(".ct_match_wrap").addClass("ct_match_1_img");
          jQuery(".ct_match_wrap").removeClass("ct_match_2_img");
        } else if (counter == 2) {
          jQuery(".ct_match_wrap").removeClass("ct_match_1_img");
          jQuery(".ct_match_wrap").addClass("ct_match_2_img");
        } else {
          jQuery(".ct_match_wrap").removeClass("ct_match_1_img ct_match_2_img");
        }

        jQuery(".ct_recommand").show();
        jQuery(".ct_match_wrap .ct_match_prod").text(
          counter + " Close Matches Found"
        );

        jQuery(".Product-rec-img").html(image_html);
        jQuery(".ct_prod_list").html(prod_html);

        setTimeout(function () {
          var img = jQuery(".slick-track .slick-active .rimage__image").attr(
            "src"
          );
          jQuery(".Product-pop-var-img  img").attr("src", img);
          jQuery(".ct_match_product_count").text(
            counter + " Close Matches Found"
          );
        }, 500);
      } else {
        var img = jQuery(".slick-track .slick-active .rimage__image").attr(
          "src"
        );
        jQuery(".Product-pop-var-img  img").attr("src", img);
        jQuery(".ct_recommand").hide();
        jQuery(".ct_match_product_count").text("0 Close Matches Found");
        jQuery(".ct_prod_list").html("");
      }
      jQuery(".ct_rec_loader").hide();
      jQuery(".ct_product_image").show();
      jQuery(".ct_match_product_count").show();
    })
    .fail(function (textStatus, errorThrown) {
      jQuery(".ct_rec_loader").hide();
      console.error("Error:", textStatus, errorThrown);
    });
}

// Clever tap event to check clicked CM Product
jQuery(document).on("click", ".pr_CPB-box", function () {
  var prod_id = jQuery(this).attr("data-product-id");
  if (prod_id) {
    clevertap.event.push("CM Product Clicked", {
      "Product ID ": prod_id,
    });
  }
});

jQuery(document).on(
  "click",
  ".ct_close_match .wishlist_fill_icon",
  function () {
    const $parent = $(this).parent();
    const groupId = $parent.attr("data-prod-variant-id");

    $.ajax({
      url: `${apiUrl}customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}&groupId=${groupId}`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    }).done(async function (response) {
      if (response.success) {
        uncheck_wishlist_added(groupId);
        var localProductData = localStorage.getItem("local_wish_prod_data");
        localProductData = localProductData ? JSON.parse(localProductData) : [];

        // Remove the specified variantId
        const index = localProductData.indexOf(groupId);
        if (index !== -1) {
          localProductData.splice(index, 1); // Remove the variantId from the array
          localStorage.setItem(
            "local_wish_prod_data",
            JSON.stringify(localProductData)
          );
        }
        var count = jQuery(".rb_wishlist_count").text();
        var total_count = parseInt(count) - 1;
        //jQuery(".rb_wishlist_count").text(total_count);
        getCollectionData(false);
        sessionStorage.setItem("wishlistFetched", "false");
        clevertap.event.push("wishlist item removed");
      }
    });
  }
);
function hexToRgb(hex) {
  // Remove the '#' character if present
  hex = hex.replace(/^#/, "");
  // Parse the hexadecimal values for each component
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  // Return an object containing the RGB values
  return { r: r, g: g, b: b };
}

function CT_pop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  jQuery(".CT_scan").show();
  setTimeout(function () {
    jQuery(".CT_scan").hide();
  }, 4500);
  var CT_element = document.querySelector(".Product-rec-pop-up");
  var CT_element_content = document.querySelector(".Product-pop-main");
  var CT_element_content_close = document.querySelector(".Product-pop-close");
  var bodyElement = document.body;

  // Clevertap Event to check the clicked Main product with
  let arr = [];
  jQuery(".pr_CPB-box").each(function () {
    prod_id = jQuery(this).attr("data-product-id");
    arr.push(prod_id);
  });

  var selected_prod = jQuery(".Product-rec-product-box.ct_product_image");
  var main_prod_id = selected_prod.attr("data-product-id");
  clevertap.event.push("CM Close Match CTA", {
    "Product ID": main_prod_id,
    "Matching Products ID's": JSON.stringify(arr),
  });

  if (CT_element) {
    checkVisibilityAndCallAPI();
    CT_element.classList.add("Pro_rec_active");
    bodyElement.classList.add("mm-no-scroll");
    bodyElement.classList.add("ct_scroll_recommandation");
    CT_element_content.classList.add("CT_element_content_open");

    CT_element_content_close.addEventListener("click", function () {
      CT_element.classList.remove("Pro_rec_active");
      CT_element_content.classList.remove("CT_element_content_open");
      bodyElement.classList.remove("mm-no-scroll");
      bodyElement.classList.remove("ct_scroll_recommandation");
    });

    CT_element.addEventListener("click", function () {
      CT_element.classList.remove("Pro_rec_active");
      CT_element_content.classList.remove("CT_element_content_open");
      bodyElement.classList.remove("mm-no-scroll");
      bodyElement.classList.remove("ct_scroll_recommandation");
    });
  }
}

async function fetchAndStoreWishlistSummary() {
  const rawData = JSON.parse(
    sessionStorage.getItem("wishlistSummaryResponse") || "{}"
  );

  if (rawData && rawData.groupByProductId) {
    fetchLocalWishlist(rawData);
  } else {
    fetchFromAPI();
  }
}

async function fetchFromAPI() {
  const url =
    "https://middleware.technoboost.in/api/v1/wishlist/wishlist-group-summary";

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const result = await response.json();

    // Store response in localStorage
    sessionStorage.setItem("wishlistSummaryResponse", JSON.stringify(result));

    // Small delay to ensure localStorage updates before calling fetchLocalWishlist
    setTimeout(() => fetchLocalWishlist(result), 100);
  } catch (error) {
    console.error("Error fetching wishlist summary:", error);
  }
}

function fetchLocalWishlist(rawData) {
  const groupByProductId = rawData.groupByProductId || [];
  const productForm = document.querySelector(".product-form");
  const productIds = productForm
    ? productForm.getAttribute("data-product-id")
    : null;

  if (!productIds) {
    console.error("Product ID not found!");
    return;
  }

  const wishlistDiv = document.querySelector(".wishlisted_product_main");
  const magnifyImage = document.querySelector(".tep_show_img");
  const productBisMark = document.querySelector(".Product_bis_mark");
  const quinnElement = document.querySelector(".quinn-element");
  const quinElementmain = document.querySelector("#quinn-cards-1");

  let count = 0;
  if (Array.isArray(groupByProductId)) {
    const productData = groupByProductId.find(
      (obj) => Object.keys(obj)[0] === productIds
    );
    count = productData ? productData[productIds] : 0;
  }

  if (productBisMark) productBisMark.style.display = "block";

  if (quinElementmain && productBisMark) {
    productBisMark.style.top = window.innerWidth < 750 ? "16px" : "24px";
  }

  if (count >= 50) {
    wishlistDiv.style.display = "block";
    formatWishlistCount(count);
    if (magnifyImage) magnifyImage.style.bottom = "55px";
    if (productBisMark)
      productBisMark.style.setProperty("bottom", "55px", "important");
    if (quinnElement) quinnElement.style.bottom = "60px";
  } else {
    if (productBisMark) {
      productBisMark.style.bottom = window.innerWidth < 750 ? "26px" : "38px";
    }
  }
}

function formatWishlistCount(count) {
  const wishlistEle = document.querySelector(".wishlisted-count");

  if (!wishlistEle) return; // Avoid errors if the element is missing

  let prdTitle = wishlistEle.getAttribute("data-prod-title");
  let prdPrice = wishlistEle.getAttribute(" data-prod-price");

  // Push event to CleverTap
  clevertap.event.push("Wishlisted_count", {
    "Product Name": prdTitle,
    "Product Price": prdPrice,
    "Wishlist Count": count, // Removed extra space in key name
  });

  // Round down to the nearest multiple of 5
  let adjustedCount = count - (count % 5);

  if (adjustedCount >= 50 && adjustedCount <= 995) {
    wishlistEle.innerHTML = `${adjustedCount}+`;
  } else if (adjustedCount >= 1000) {
    let formattedCount = (adjustedCount / 1000).toFixed(1).replace(/\.0$/, "");
    wishlistEle.innerHTML = `${formattedCount}k+`;
  } else {
    wishlistEle.innerHTML = count; // Show exact count if below 50
  }
}

// Run function
fetchAndStoreWishlistSummary();

// Product Recommendations

async function fetchCollectionList(uniqueId, customerId) {
  try {
    const response = await $.ajax({
      url: `${apiUrl}wishlist/collection?registrationId=${uniqueId}&customerId=${customerId}`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    return response || [];
  } catch (error) {
    console.error("Error fetching collection list:", error);
    return [];
  }
}

function checkVisibilityAndCallAPI() {
  var wishLocalData = localStorage.getItem("local_wish_prod_data");
  if (wishLocalData != null) {
    // This checks both for null and empty string
    if (wishLocalData != "") {
      var get_wish_local_data = JSON.parse(wishLocalData);
      if (
        Array.isArray(get_wish_local_data) &&
        get_wish_local_data.length > 0
      ) {
        jQuery.each(get_wish_local_data, function (index, element) {
          check_wishlist_added(element);
        });
      }
    }
  } else {
    wishlist_product_list();
  }
}

function check_wishlist_added(variantId) {
  jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`).addClass(
    "active"
  );
}

jQuery(document).on(
  "click",
  ".ct_close_match .wishlist_fill_icon",
  function () {
    const $parent = $(this).parent();
    const groupId = $parent.attr("data-prod-variant-id");
    var uniqueId = getCookie("browserUniqueId") || generateUniqueId();

    $.ajax({
      url: `${apiUrl}customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}&groupId=${groupId}`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    }).done(async function (response) {
      if (response.success) {
        uncheck_wishlist_added(groupId);
        var localProductData = localStorage.getItem("local_wish_prod_data");
        localProductData = localProductData ? JSON.parse(localProductData) : [];

        // Remove the specified variantId
        const index = localProductData.indexOf(groupId);
        if (index !== -1) {
          localProductData.splice(index, 1); // Remove the variantId from the array
          localStorage.setItem(
            "local_wish_prod_data",
            JSON.stringify(localProductData)
          );
        }
        var count = jQuery(".rb_wishlist_count").text();
        var total_count = parseInt(count) - 1;
        //jQuery(".rb_wishlist_count").text(total_count);
        getCollectionData(false);

        clevertap.event.push("wishlist item removed");
      }
    });
  }
);

let imageHtml = "";
let sku;

const animateModal = document.getElementById("bundle-overlay-animate");
const modalElement = document.getElementById("bundle-prd-modal");
const bundlePrdt = document.getElementById("bundle-prdts");
const animateElement = document.getElementById("bundle-prd-animate");

let loaderElement = document.querySelector(".product-related-div .ct-rp-wrap");
let relatedProdContainer = document.querySelector(".product-related-container");
let imageContainer = document.querySelector(".product-related-images");
const variantSelector = document.querySelector(".original-selector");

const displaySku = async () => {
  if (!variantSelector) return false; // Prevent execution if selector is missing

  sku =
    variantSelector.options[variantSelector.selectedIndex]?.getAttribute(
      "data-sku"
    );
  if (!sku) return false; // Ensure SKU is valid

  try {
    const response = await fetch(
      `https://middleware.technoboost.in/api/v1/callback/products-type-wise?sku=${sku}`
    );

    if (!response.ok) {
      console.error("Server error:", response.status);
      return false;
    }

    const data = await response.json();
    let displayCount = 0;
    imageContainer.innerHTML = "";

    Object.keys(data.product).forEach((productName) => {
      relatedProdContainer.removeAttribute("style");
      loaderElement.style.display = "none";

      data.product[productName].forEach((item) => {
        if (displayCount < 3) {
          let image = document.createElement("img");
          image.setAttribute("loading", "eager");
          image.setAttribute("fetchpriority", "high");

          let imgUrl = item.image.includes("?")
            ? `${item.image}&width=100`
            : `${item.image}?width=100`;
          image.src = imgUrl;
          image.width = 100; // Explicit width
          image.height = 100; // Explicit height
          image.alt = "Product-rec-img";

          imageContainer.appendChild(image);
          displayCount++;
        }
      });
    });

    if (displayCount < 3) {
      console.warn("Less than 3 products available, returning false.");
      return false;
    }

    if (!closeMatchAPI) {
      data_add();
    }

    return true;
  } catch (error) {
    loaderElement.style.display = "none";
    console.error("Error fetching products:", error);
    return false;
  }
};

if (variantSelector) {
  relatedProdContainer.addEventListener("click", redirectToExplore);
}

// CODE FOR OPEN BUNDLE PRODUCT MODAL

function openModalBundle() {
  document.querySelector("body").classList.add("mm-no-scroll");
  const screenWidth = window.innerWidth;

  if (screenWidth < 750) {
    modalElement.classList.add("show");
    animateModal.classList.add("show");

    setTimeout(() => {
      animateElement.classList.add("show");
    }, 600);

    setTimeout(() => {
      animateElement.classList.remove("show");
    }, 1600);

    setTimeout(() => {
      animateElement.style.display = "none";
      bundlePrdt.classList.add("show");
    }, 2000);
  }
}

function closeModalBundle() {
  document.getElementById("bundle-overlay-animate").classList.remove("show");
  document.getElementById("bundle-prd-modal").classList.remove("show");
  document.querySelector("body").classList.remove("mm-no-scroll");
  modalElement.classList.add("show");
}

function redirectToExplore() {
  let currentProd = document.querySelector(".product-related-container");
  if (currentProd) {
    let prdTitle = currentProd.getAttribute("data-prod-name");
    let prdPrice = currentProd.getAttribute("data-prod-price");
    let prdId = currentProd.getAttribute("data-prod-id");

    // Push event to CleverTap
    clevertap.event.push("Bundling_click", {
      "Product Name": prdTitle,
      "Product Price": prdPrice,
      "Product ID": prdId, // Removed extra space in key name
    });
  }

  sessionStorage.setItem("bundlingsku", sku);
  setTimeout(() => {
    window.location.href = `/pages/product-bundling?${sku}`;
  }, 50);
}

// Close modal when clicking outside of it
document.getElementById("bundle-overlay-animate")?.addEventListener("click", (e) => {
  if (e.target === document.getElementById("bundle-overlay-animate")) {
    closeModalBundle();
    let currentProd = document.querySelector(".product-related-container");
    if (currentProd) {
      let prdTitle = currentProd.getAttribute("data-prod-name");
      let prdPrice = currentProd.getAttribute("data-prod-price");
      let prdId = currentProd.getAttribute("data-prod-id");
      clevertap.event.push("Close_Bundling", {
        "Product Name": prdTitle,
        "Product Price": prdPrice,
        "Product ID": prdId,
      });
    }
  }
});


document.querySelector('.custom-close-modal').addEventListener('click', function() {
  closeModalBundle();
  let currentProd = document.querySelector(".product-related-container");
    if (currentProd) {
      let prdTitle = currentProd.getAttribute("data-prod-name");
      let prdPrice = currentProd.getAttribute("data-prod-price");
      let prdId = currentProd.getAttribute("data-prod-id");
      clevertap.event.push("Close_Bundling", {
        "Product Name": prdTitle,
        "Product Price": prdPrice,
        "Product ID": prdId,
      });
    }
});


document.addEventListener('DOMContentLoaded', function () {
  let shopByCollection = document.querySelectorAll('.collection-tag-pdp');

  shopByCollection.forEach((e) => {
    e.addEventListener('click', function () {
      clevertap.event.push("Clicked Shop By Collection", {
        collectionText: e.textContent.trim(),
        url: e.href
      });
    });
  });
});
